<form (submit)="onSubmit()" class="autocomplete__wrapper">
  <mat-icon class="autocomplete__icon">search</mat-icon>
  <input #queryField type="search" [matAutocomplete]="acTrigger.auto" [(ngModel)]="query"
         [formControl]="searchCtrl" (focus)="onQueryFocus($event)" class="autocomplete__search"
         aria-label="Search" placeholder="Search" autocomplete="off" autocorrect="off">
</form>

<!-- Regular autocomplete for supported browsers -->
<app-autocomplete-trigger #acTrigger
  [query]="query"
  [searchCtrl]="searchCtrl"
  (itemSelected)="onItemSelected($event)">
</app-autocomplete-trigger>

<!-- Alternative UI for iOS/Android -->
<app-autocomplete-overlay #acOverlay (itemSelected)="onItemSelected($event)"></app-autocomplete-overlay>
